import { useCallback } from 'react';

const GOOGLE_OAUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';

const SCOPES = [
  'https://www.googleapis.com/auth/drive.file',
  'https://www.googleapis.com/auth/userinfo.email',
];

function buildRedirectUri(): string {
  return `${window.location.origin}/oauth/google/callback`;
}

export function getGoogleOAuthRedirectUri(): string {
  return buildRedirectUri();
}

export function useStartGoogleOAuth() {
  const startOAuth = useCallback((spaceId: string) => {
    const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
    if (!clientId) {
      throw new Error('VITE_GOOGLE_CLIENT_ID manquant.');
    }

    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: buildRedirectUri(),
      response_type: 'code',
      scope: SCOPES.join(' '),
      // access_type=offline + prompt=consent are required to ensure Google
      // returns a refresh_token (even when the user has consented before).
      access_type: 'offline',
      prompt: 'consent',
      include_granted_scopes: 'true',
      state: spaceId,
    });

    window.location.href = `${GOOGLE_OAUTH_URL}?${params.toString()}`;
  }, []);

  return { startOAuth };
}
